import { BaseSensor } from './BaseSensor';
import { Device } from './Device';
import { TranslationService } from '../services/translation.service';
export class HeatingCircuit extends Device {
	private internal_id = 0;
	static _id: number;
	translator: TranslationService;
	getId() {
		return this.id;
	}
	constructor(id: number) {
		super(id);
		this.translator = TranslationService.getInstance();
		this.internal_id = HeatingCircuit._id;
		HeatingCircuit._id++;
		this.id = id;
		this.scales = new Map<string, BaseSensor>();
		this.values = new Map<string, string>();

		let room_temp_nom_quick = BaseSensor.fromArgs(
			"room_temperature_nominal_quick",
			20,
			4.5,
			30,
			0.5,
			"AICI_UNIT_CELSIUS"
		);
		room_temp_nom_quick.setSpecialValue(4.5, "AICI_OFF_NORMAL", "iconHeatingDis");
		this.scales.set('room_temperature_nominal_quick', room_temp_nom_quick);

		this.values.set('circuitType', 'DELIGHT_SYSTEM_CONFIG_MENU_ENTRY_HEATING');
		this.values.set('circuitState', 'DELIGHT_MAIN_MENU_ENTRY_CURRENT_STATUS_VALUE_0');
		this.scales.set('wunschtemperatur_heizen', BaseSensor.fromArgs('wunschtemperatur_heizen', 20, 15, 37, 0.5, "AICI_UNIT_CELSIUS"));
		this.scales.set("vorlaufsolltemp", BaseSensor.fromArgs("vorlaufsolltemp", 50, 29, 90, 0.5, "AICI_UNIT_CELSIUS"));
		this.scales.set("vorlaufisttemp", BaseSensor.fromArgs("vorlaufisttemp", 50, 0, 90, 0.5, "AICI_UNIT_CELSIUS"));
		this.scales.get("vorlaufsolltemp").setSpecialValue(29, "AICI_OFF_NORMAL", "iconHeatingDis");
		this.scales.set("at_abschaltgrenze", BaseSensor.fromArgs("at_abschaltgrenze", 21, 10, 99, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("vorlaufsolltemp_wunsch", BaseSensor.fromArgs("vorlaufsolltemp_wunsch", 65, 5, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("vorlaufsolltemp_absenkwunsch", BaseSensor.fromArgs("vorlaufsolltemp_absenk", 0, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("warmwassertemperatur", BaseSensor.fromArgs("warmwassertemperatur", 60, 35, 70, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("speicher_ist_temperatur", BaseSensor.fromArgs("speicher_ist_temperatur", 31, 0, 99, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("rücklauf_soll_temperatur", BaseSensor.fromArgs("rücklauf_soll_temperatur", 30, 15, 80, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("heizkurve", BaseSensor.fromArgs("heizkurve", 1.2, 0.1, 4, 0.05, ""));
		this.scales.set("min_vorlauf_soll_temperatur", BaseSensor.fromArgs("min_vorlauf_soll_temperatur", 15, 15, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("max_vorlauf_soll_temperatur", BaseSensor.fromArgs("max_vorlauf_soll_temperatur", 90, 15, 90, 1, "AICI_UNIT_CELSIUS"));
		this.values.set('absenkmodus', 'ENUM_AUTO_OFF_MODE_ECO');
		this.values.set('raumaufschaltung', 'DELIGHT_GREEN_IQ_INACTIVE');
		this.values.set('kuehlen_moeglich', 'AICI_NO_NORMAL');
		this.values.set('taupunktüberwachung', 'ENUM_DEW_POINT_MONITORING_YES');

		this.scales.set("min_vorlauftemp_kuehlen", BaseSensor.fromArgs("min_vorlauftemp_kuehlen", 20, 7, 24, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("offset_taupunkt", BaseSensor.fromArgs("offset_taupunkt", 2, -10, 10, 1, "AICI_UNIT_KELVIN"));
		this.values.set('externe_waermeanforderung', 'ENUM_STATUS_EXTERNAL_HEAT_DEMAND_OFF');
		this.values.set('status_pumpe', 'ENUM_CIRCUIT_PUMP_STATUS_OFF');

		this.scales.set("status_mischventil", BaseSensor.fromArgs("status_mischventil", 0, 0, 100, 1, "AICI_UNIT_PERCENT"));

		this.scales.set("estrichtTrocknungsTag", BaseSensor.fromArgs("estrichtTrocknungsTag", 0, 0, 29, 1, ""));
	}

	getScale(key: string): BaseSensor {
		return this.scales.get(key);
	}
	getScaleValue(key: string) {
		return this.scales.get(key).getCurrentValue();
	}

	setValue(key: string, value: string) {
		this.values.set(key, value);
	}
	getValue(key) {
		return this.translator.tr(this.values.get(key));
	}
	getRawValue(key) {
		return this.values.get(key);
	}
	hasValue(key) {
		return this.values.has(key);
	}
	hasScale(key) {
		return this.scales.has(key);
	}

}